import { connect } from 'react-redux';
import {
    getActiveModal, hideModal, MODAL_REMOVE_ASSISTANT
} from "../../../reducers/common/activeModal";
import {getTranslation} from "../../../reducers/common/localization";
import RemoveAssistantModal from "./RemoveAssistantModal";
import {onRemoveAssistant} from "../../../reducers/assistant/assistants";

const mapStateToProps = state => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_REMOVE_ASSISTANT,
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAssistantRemove: (id) => {
            dispatch(onRemoveAssistant(id));
        },
        onClose: () => {
            dispatch(hideModal());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveAssistantModal);



// WEBPACK FOOTER //
// ./src/components/assistantsManagement/removeAssistantModal/RemoveAssistantModal.container.js